var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_7499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1584 1.31592H2.63169C1.90798 1.31592 1.32244 1.90804 1.32244 2.63175L1.31586 14.4743L3.94752 11.8426H13.1584C13.8821 11.8426 14.4742 11.2505 14.4742 10.5268V2.63175C14.4742 1.90804 13.8821 1.31592 13.1584 1.31592ZM13.1584 10.5268H3.40145L3.01328 10.9149L2.63169 11.2965V2.63175H13.1584V10.5268ZM3.94752 7.89508H5.26336V9.21092H3.94752V7.89508ZM3.94752 5.92133H5.26336V7.23717H3.94752V5.92133ZM3.94752 3.94758H5.26336V5.26342H3.94752V3.94758ZM6.57919 7.89508H9.86877V9.21092H6.57919V7.89508ZM6.57919 5.92133H11.8425V7.23717H6.57919V5.92133ZM6.57919 3.94758H11.8425V5.26342H6.57919V3.94758Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_7499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.79,
    height: 15.79,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswers);
export default __webpack_public_path__ + "static/media/answers.70293cdd6f2af0adf6410dce46fc0f89.svg";
export { ForwardRef as ReactComponent };